import React from "react";
import {Select} from "antd";
import {shiftRequestTypes} from "constants/constants";

export const RequestTypeFilter = ({
    value,
    onChange,
    allowClear = true,
    placeholder = "Talep Türü Seç",
    style = {minWidth: "150px"}
}) => {
    return (
        <Select
            placeholder={placeholder}
            style={style}
            allowClear={allowClear}
            value={value}
            onChange={onChange}
            options={shiftRequestTypes}
        />
    );
};
